export default {"src":"/oferta/_next/static/media/yoga.415bacf0.svg","height":39,"width":47,"blurWidth":0,"blurHeight":0};